(() => {
  const storageKey = 'coastlineCollectionGrid';
  const observedContainers = new WeakSet();

  const getSavedView = () => {
    try {
      return localStorage.getItem(storageKey) || 'comfortable';
    } catch (error) {
      return 'comfortable';
    }
  };

  const saveView = (view) => {
    try {
      localStorage.setItem(storageKey, view);
    } catch (error) {
      // The preference remains active for the current page when storage is unavailable.
    }
  };

  const applyView = (component, view) => {
    if (!component) return;
    component.dataset.gridView = view;
    component.querySelectorAll('[data-coastline-grid]').forEach((button) => {
      button.setAttribute('aria-pressed', button.dataset.coastlineGrid === view ? 'true' : 'false');
    });
  };

  const init = () => {
    const savedView = getSavedView();
    document.querySelectorAll('collection-component').forEach((component) => applyView(component, savedView));
    document.querySelectorAll('#ProductGridContainer').forEach((container) => {
      if (observedContainers.has(container)) return;
      observedContainers.add(container);
      new MutationObserver(init).observe(container, { childList: true });
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-coastline-grid]');
    if (!button) return;
    const component = button.closest('collection-component');
    const view = button.dataset.coastlineGrid;
    saveView(view);
    applyView(component, view);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
